import { createSvgIcon } from '@mui/material';

export const ThumbIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none">
    <path
      d="M5.38623 12.8879L5.67581 13.0617C5.90748 13.1775 6.19706 13.2354 6.48664 13.2354H10.4829C11.5254 13.2354 12.3941 12.4825 12.5678 11.4979L13.4366 6.98048C13.6103 6.16965 12.9733 5.47466 12.1624 5.47466H9.84578L10.8304 2.75259C10.8883 2.63676 10.8883 2.52093 10.8883 2.4051C10.8883 1.82593 10.4249 1.30469 9.78787 1.30469C9.44037 1.30469 9.15079 1.47844 8.91912 1.7101L5.50206 6.22757H5.38623"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.74918 13.6986H1.04254C0.695044 13.6986 0.463379 13.467 0.463379 13.1195V5.87994C0.463379 5.53245 0.695044 5.30078 1.04254 5.30078H4.8071C5.1546 5.30078 5.38626 5.53245 5.38626 5.87994V13.1774C5.32834 13.467 5.09668 13.6986 4.74918 13.6986Z"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  'Thumb',
);
